module.exports = __webpack_public_path__ + "static/img/JASPER-HAY.87f1919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JASPER-HAY.jpg
// module id = s1mZ
// module chunks = 0